export type Digit = number

const validateDigits = (digits: Digit[]) => {
  if (!Array.isArray(digits) || digits.length < 3) {
    throw new Error('กรุณาเลือกตัวเลขอย่างน้อย 3 ตัวขึ้นไป')
  }
  for (const d of digits) {
    if (!Number.isInteger(d) || d < 0 || d > 9) {
      throw new Error('ตัวเลขต้องเป็น 0-9 เท่านั้น')
    }
  }
}

export function genWin2KeepOrderNoDouble(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []
  for (let i = 0; i < digits.length; i++) {
    for (let j = 0; j < digits.length; j++) {
      if (i === j) continue
      const a = digits[i]
      const b = digits[j]
      if (a === b) continue
      out.push(`${a}${b}`)
    }
  }
  return out
}

export function genWin2KeepOrderIncludeDouble(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []
  for (let i = 0; i < digits.length; i++) {
    for (let j = 0; j < digits.length; j++) {
      if (i === j) continue
      out.push(`${digits[i]}${digits[j]}`)
    }
  }
  for (const d of digits) out.push(`${d}${d}`)
  return out
}

function perm3(a: number, b: number, c: number): string[] {
  return [
    `${a}${b}${c}`,
    `${a}${c}${b}`,
    `${b}${a}${c}`,
    `${b}${c}${a}`,
    `${c}${a}${b}`,
    `${c}${b}${a}`,
  ]
}

export function genWin3KeepOrderNoHamNoTong(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []
  for (let i = 0; i < digits.length; i++) {
    for (let j = i + 1; j < digits.length; j++) {
      for (let k = j + 1; k < digits.length; k++) {
        const a = digits[i]
        const b = digits[j]
        const c = digits[k]
        if (a === b || a === c || b === c) continue
        out.push(...perm3(a, b, c))
      }
    }
  }
  return out
}

export function genWin3KeepOrderIncludeHamTong(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []
  for (let i = 0; i < digits.length; i++) {
    for (let j = 0; j < digits.length; j++) {
      for (let k = 0; k < digits.length; k++) {
        out.push(`${digits[i]}${digits[j]}${digits[k]}`)
      }
    }
  }
  return out
}
